import styled from '@emotion/styled';

import { ModalContent } from 'components/global/styled/Modal.styled';

export const Content = styled(ModalContent)`
	gap: 1rem;
	display: flex;
	flex-direction: column;
	flex: 1;
`;

export const NoCartContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	justify-content: center;
	align-items: center;
	.empty-cart-img {
		padding-bottom: var(--padding-5);
	}
`;

export const NoCartContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
`;

export const ProductContainer = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	padding: var(--padding-2);
	border-bottom: 1px solid var(--border-2);
	border: 1px solid var(--border-color);
	border-radius: 0.5rem;
`;

export const ProductActionContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-left: var(--margin-4);
	gap: 1rem;
	opacity: ${({ isLoading }) => (isLoading ? 0.3 : 1)};
`;

export const Row = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const ProductQuantityContainer = styled.div`
	width: 16rem;
`;

export const LoadingContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: var(--z-index-1);
	width: calc(100% - var(--padding-2)) !important;
	.loading {
		height: 100% !important;
		width: 100% !important;
	}
`;

export const CartSummaryContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin: 2rem 0;
`;

export const SummaryRow = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const Divider = styled.div`
	width: 100%;
	border-bottom: 1px solid var(--border-color);
`;
